import React from 'react';
import ReactLoading from 'react-loading';
import styled from 'styled-components';
import useHandleAddToWaitlist from '../../../../hooks/useHandleAddToWaitlist';
import { TransparentButton } from '../../../../styles/theme/default/buttons';

const Wrapper = styled.div`
  .loading-container {
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .waitlist-btn {
    margin-top: 15px;
    width: 100%;
  }

  .button-text {
    display: flex;
    justify-content: center;
  }
`;

function WaitlistButton({ product }) {
  const [
    handleWaitlist,
    { loading, checkIfInWaitlist }
  ] = useHandleAddToWaitlist();

  return (
    <Wrapper>
      <TransparentButton
        className="waitlist-btn"
        onClick={() => handleWaitlist(product.id)}
        disabled={loading}
      >
        {loading ? (
          <div className="loading-container">
            <ReactLoading height={30} width={30} type="balls" color="#888888" />
          </div>
        ) : (
          <span className="button-text">
            {checkIfInWaitlist(product.id)
              ? 'Remove from Waitlist'
              : 'Add to Waitlist'}
          </span>
        )}
      </TransparentButton>
    </Wrapper>
  );
}

export default WaitlistButton;
